import React from "react";
import PropTypes from "prop-types";

function ButtonPrimary(props) {
  function _renderIcon(params) {
    if (!!props.icon) return <props.icon className="h-4 w-4 mr-2" />;

    return null;
  }

  let className =
    props.type === "solid"
      ? "px-4 py-2 flex w-full text-center justify-center flex-row items-center rounded-lg bg-blue-500 text-white shadow-xl hover:shadow-2xl"
      : "px-4 py-2 flex w-full text-center justify-center flex-row items-center rounded-lg border border-blue-500 text-blue-500 shadow-xl hover:shadow-2xl";
  return (
    <div>
      <button className={className} onClick={() => props.onClick()}>
        {_renderIcon()}
        <p className="text-sm">{props.text}</p>
      </button>
    </div>
  );
}

ButtonPrimary.defaultProps = {
  onClick: function onClick(params) {
    return null;
  },
};

ButtonPrimary.propTypes = {
  icon: PropTypes.element,
  type: PropTypes.oneOf(["solid", "outline"]).isRequired,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  text: PropTypes.string,
  // onClick: PropTypes.func,
};

export default ButtonPrimary;
